export const setupFeatureFlagConsoleCommands = () => {
  /**
   * Habilita a funcionalidade de assinaturas
   */
  window.enableSubscriptions = () => {
    localStorage.setItem('feature_flag_subscriptions', 'true');
    console.log('%c✅ Feature "Assinaturas" habilitada!', 'color: #4caf50; font-size: 14px; font-weight: bold;');
    console.log('%cRecarregue a página para ver as mudanças.', 'color: #2196f3; font-size: 12px;');
    window.dispatchEvent(new Event('featureFlagChanged'));
    return '🎉 Sucesso! Recarregue a página (F5) para ver as mudanças.';
  };

  /**
   * Desabilita a funcionalidade de assinaturas
   */
  window.disableSubscriptions = () => {
    localStorage.removeItem('feature_flag_subscriptions');
    console.log('%c❌ Feature "Assinaturas" desabilitada!', 'color: #f44336; font-size: 14px; font-weight: bold;');
    console.log('%cRecarregue a página para ver as mudanças.', 'color: #2196f3; font-size: 12px;');
    window.dispatchEvent(new Event('featureFlagChanged'));
    return '👋 Feature desabilitada! Recarregue a página (F5).';
  };

  /**
   * Lista todas as feature flags ativas
   */
  window.listFeatureFlags = () => {
    const flags = Object.keys(localStorage)
      .filter(key => key.startsWith('feature_flag_'))
      .map(key => ({
        feature: key.replace('feature_flag_', ''),
        enabled: localStorage.getItem(key) === 'true',
        key: key
      }));
    
    if (flags.length === 0) {
      console.log('%cNenhuma feature flag ativa', 'color: #ff9800; font-size: 12px;');
      return 'Nenhuma feature flag ativa';
    }

    console.table(flags);
    return flags;
  };

  /**
   * Remove todas as feature flags
   */
  window.clearAllFeatureFlags = () => {
    const flagKeys = Object.keys(localStorage).filter(key => key.startsWith('feature_flag_'));
    
    if (flagKeys.length === 0) {
      console.log('%cNenhuma feature flag para remover', 'color: #ff9800; font-size: 12px;');
      return 'Nenhuma feature flag ativa';
    }

    flagKeys.forEach(key => localStorage.removeItem(key));
    console.log(`%c🧹 ${flagKeys.length} feature flag(s) removida(s)`, 'color: #4caf50; font-size: 14px; font-weight: bold;');
    console.log('%cRecarregue a página para ver as mudanças.', 'color: #2196f3; font-size: 12px;');
    window.dispatchEvent(new Event('featureFlagChanged'));
    return `${flagKeys.length} feature flag(s) removida(s). Recarregue a página.`;
  };
};
